// API Configuration for different environments
const getApiBaseUrl = () => {
  return 'https://rendery.org/api'
}

// Export the base URL and a helper function for making API calls
export const API_BASE_URL = getApiBaseUrl()

console.log('API_BASE_URL', API_BASE_URL)

// Helper function to construct full API URLs
export const apiUrl = (endpoint) => {
  // Remove leading slash if present to avoid double slashes
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint
  return `${API_BASE_URL}/${cleanEndpoint}`
}

// Helper function for making authenticated API calls
export const apiCall = async (endpoint, options = {}) => {
  const url = apiUrl(endpoint)
  const token = localStorage.getItem('auth_token')
  
  const defaultHeaders = {
    'Content-Type': 'application/json',
  }
  
  if (token) {
    defaultHeaders['Authorization'] = `Bearer ${token}`
  }
  
  const config = {
    ...options,
    headers: {
      ...defaultHeaders,
      ...(options.headers || {})
    }
  }
  
  try {
    const response = await fetch(url, config)
    const data = await response.json()
    
    // Handle 401 unauthorized responses globally
    if (response.status === 401) {
      // Clear auth state on unauthorized
      localStorage.removeItem('auth_token')
      localStorage.removeItem('auth_user')
      
      // Redirect to login if not already there
      if (window.location.pathname !== '/') {
        window.location.href = '/'
      }
      
      throw new Error('Unauthorized - please log in again')
    }
    
    return { response, data }
  } catch (error) {
    if (process.env.NODE_ENV === 'development') {
      console.error(`API call failed for ${endpoint}:`, error)
    }
    throw error
  }
}

// Environment info for debugging
export const ENV_INFO = {
  isDevelopment: process.env.NODE_ENV === 'development',
  isProduction: process.env.NODE_ENV === 'production',
  apiBaseUrl: API_BASE_URL,
  hostname: typeof window !== 'undefined' ? window.location.hostname : 'unknown'
}

// Log API configuration in development only
if (process.env.NODE_ENV === 'development') {
  console.log('API Configuration:', ENV_INFO)
} 